import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../theme';

const { colors, fonts, fontSize, spacing, sizes } = redesignTheme;

export const useIAChatInputStyles = makeStyles(() => ({
  inputContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 20,
    height: 80,
    minHeight: 80,
    padding: `0 ${spacing.md}px`,
    borderTop: `1px solid ${colors.chatBorder}`,
    backgroundColor: colors.white,
    flexShrink: 0,
    boxSizing: 'border-box',
  },
  input: {
    flex: 1,
    minWidth: 0,
    border: 'none',
    outline: 'none',
    resize: 'none',
    backgroundColor: 'transparent',
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    lineHeight: '20px',
    color: colors.text,
    maxHeight: 48,
    padding: 0,
    margin: 0,
    '&::placeholder': {
      color: colors.chatInputPlaceholder,
      opacity: 1,
    },
    '&:disabled': {
      cursor: 'not-allowed',
      opacity: 0.6,
    },
  },
  sendButton: {
    width: sizes.chatSendButtonSize,
    height: sizes.chatSendButtonSize,
    minWidth: sizes.chatSendButtonSize,
    padding: 17,
    border: 'none',
    borderRadius: '50%',
    backgroundColor: colors.primary,
    color: colors.white,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxSizing: 'border-box',
    '&:hover:not(:disabled)': {
      backgroundColor: colors.primaryDark,
    },
    '&:disabled': {
      backgroundColor: colors.chatBubbleAssistant,
      cursor: 'not-allowed',
    },
  },
  sendIcon: {
    width: 20,
    height: 20,
    display: 'block',
  },
}));
